import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogTitle from '@material-ui/core/DialogTitle';
import Loader from 'react-loader-spinner';
import {isMobile} from 'react-device-detect'
import { login } from '../api'
import './general.css'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});

const pwresetstyle = {
  textAlign: 'center',
  fontSize : '75%'
}

export default class Loginpopup extends React.Component {
	constructor(props){
	  super(props);

	  this.state={
	  username:'',
	  password:'',
    stayloggedin: isMobile,
    open :  false,
    counter : 0,
    disabled : false,
    loading:false,
	}
}


//componentDidUpdate () {
//  console.log('new props');
//  this.setState({open : this.props.open});
//}

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.handleClick(e);
    }
  }

  handleClick(event){
  var self = this;
  this.setState({disabled:true})
  this.setState({loading:true})
  login(this.state.username,this.state.password)
  .then(function (response) {
   if(response.status === 200){
      self.setState({loading:false})
      self.setState({disabled:false})
      self.props.onGotuser(response.data,self.state.stayloggedin);
      //self.handleClose();
    }
   else{
     self.setState({disabled:false,loading:false,password:''})
     localStorage.removeItem('access_token')
     sessionStorage.removeItem('access_token')
     console.log("Username does not exists");

    }
 })
 .catch(function (error) {
   console.log(error);
   localStorage.removeItem('access_token')
   sessionStorage.removeItem('access_token')
   let counter = self.state.counter
   counter += 1
   self.setState({disabled:false,loading:false,password:''})
   self.setState({counter : counter})
 });
}


  render() {
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          disableBackdropClick={true}
        >
          <DialogTitle id="form-dialog-title">Login</DialogTitle>
          <DialogContent>
            <TextField
               helperText="Benutzernamen eingeben"
               label="Benutzername"
               value={this.state.username}
               onChange = {(e) => this.setState({username:e.target.value})}
             />
           <br/>
             <TextField
               type="password"
               helperText="Passwort eingeben"
               label="Passwort"
               value={this.state.password}
               onChange = {(e) => this.setState({password:e.target.value})}
               onKeyPress = {(e) => this.handleEnter(e)}
               />
            <br/>
            <FormControlLabel
              control={
              <Checkbox
              checked = {this.state.stayloggedin}
                onChange={(event) => this.setState({stayloggedin : event.target.checked})}
                color="primary"
                />
            }
            label = 'Angemeldet bleiben'/>
            {this.state.counter > 2 && 
              <div style={pwresetstyle}> Achtung! Bei mehrfach falschem Passwort wird Aldente-Login gesperrt </div>
            }
            </DialogContent>
          <DialogActions>
             <Button variant="contained" disabled={this.state.disabled} color="primary" primary='true' onClick={(event) => this.handleClick(event)}>
             Absenden
             </Button>
          </DialogActions>
        </Dialog>
        {this.state.loading && <Loader className='waitingloader' type="Circles" color="#00BFFF" height={80} width={80}/>}
      </div>
    );
  }
}
